import React, { useState, useEffect, useRef }  from 'react';

const IFrameSource = ({title, src}) => {
    const [height, setHeight] = useState(0);
    const iframeRef = useRef(null);

    useEffect(() => {
        const handleMessage = (e) => {
            const receivedHeight = e.data?.height ?? null;
            const isValidHeight = (receivedHeight) ? !isNaN(receivedHeight) : false;

            if (isValidHeight) {
                setHeight(receivedHeight);
            }

            if (e.data?.scrollToTop) {
                iframeRef.current?.scrollIntoView({ behavior: 'instant' });
            }
        };

        window.addEventListener("message", handleMessage); 

        return () => {
            window.removeEventListener("message", handleMessage);
        };
    }, []);

    /**
     * scrolling is always "no" — the iframe always has an explicit height.
     * height > 0: real height in px received via postMessage.
     * height === 0: 100vh placeholder until the first message arrives or on navigation reset.
     */
    return (src) ? (
        <iframe 
            ref={ iframeRef }
            className="iframe-content"
            title={ title ?? '' }
            scrolling={ height > 0 ? "no" : "yes" }
            style={ height > 0 ? { height: `${height}px` } : null }
            src={ src }></iframe>
    ) : null;
}

export default IFrameSource;
